import { render, staticRenderFns } from "./LightningSvg.vue?vue&type=template&id=542efbb7&"
import script from "./LightningSvg.vue?vue&type=script&lang=ts&"
export * from "./LightningSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports